'use client'

import React from 'react'
import { Card, CardContent } from '@/components/ui'
import { Button } from '@/components/ui/button'
import { X, Volume2, Crown, Sparkles } from 'lucide-react'
import { useRouter } from 'next/navigation'

interface TrialPromotionModalProps {
  onShowRoleModal: () => void
  onClose: () => void
}

export const TrialPromotionModal: React.FC<TrialPromotionModalProps> = ({ 
  onShowRoleModal, 
  onClose 
}) => {
  const router = useRouter()

  const handleSubscribe = () => {
    router.push('/subscribe')
  }

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-md bg-gray-900 border-gray-700">
        <CardContent className="p-6">
          {/* 標題和關閉按鈕 */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-yellow-400" />
              <h2 className="text-xl font-bold text-white">很好玩吧！</h2>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              className="text-gray-400 hover:text-white"
            >
              <X className="h-5 w-5" />
            </Button>
          </div>

          {/* 提示文字 */}
          <p className="text-gray-300 mb-6 text-center">
            現在就正式訂閱，解鎖更多角色吧～
          </p>

          {/* 按鈕組 */}
          <div className="flex flex-col gap-3">
            <Button
              onClick={handleSubscribe}
              className="w-full bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700"
            >
              <Crown className="h-4 w-4 mr-2" />
              立即訂閱
            </Button>
            
            <Button
              onClick={onShowRoleModal}
              variant="outline"
              className="w-full"
            >
              <Volume2 className="h-4 w-4 mr-2" />
              試聽角色語音
            </Button>
            
            <Button
              onClick={onClose}
              variant="ghost"
              className="w-full"
            >
              繼續試用50音
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

